import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { notify } from "../../actions/notify";

const InvoiceActions = ({
  handleSendInvoice,
  showRegister,
  setShowRegister,
  itemId,
  setItemId,
  item,
  handleDownloadInvoice,
  handleSendReminder,
  setShowPayments,
  setDeleteId,
  setShowDelete,
  setShowNonRecoverable,
  setShowDelayCharges
}) => {
  const [selectedContacts, setSelectedContacts] = useState([]);
  const enabledDelayCharges = item?.project_array?.client_array?.enable_delay_charges
  const handleCheckboxChange = (contact) => {
    setSelectedContacts((prev) => {
      if (prev.some((item) => item.id === contact.id)) {
        return prev.filter((item) => item.id !== contact.id);
      } else {
        return [...prev, contact];
      }
    });
  };
  const [show, setShow] = useState(false);
  const invoiceActionOptions = [
    { value: "register_payment", label: "Register payment" },
    { value: "download_invoice", label: "Download Invoice" },
    { value: "payments", label: "Payments" },
    // enabledDelayCharges && { value: "delay_charges", label: "Delay Charges" },
    // { value: "delay_charges", label: "Delay Charges" },
    { value: "mark_non_recoverable", label: "Mark Non-recoverable" },
    { value: "view", label: "View" },
    { value: "edit", label: "Edit" },
    { value: "delete", label: "Delete" },
  ].filter(Boolean);
  const [invoiceAction, setInvoiceAction] = useState("");
  const [selected, setSelected] = useState("");

  let options = invoiceActionOptions;

  if (item?.status === "NON-RECOVERABLE") {
    options = invoiceActionOptions.filter(
      (option) => option.value !== "mark_non_recoverable"
    );
  } else if (item?.status === "PAID") {
    options = invoiceActionOptions.filter(
      (option) =>
        option.value !== "edit" &&
        option.value !== "delete" &&
        option.value !== "register_payment" &&
        option.value !== "mark_non_recoverable"
    );
  } else if (item?.status === "PENDING") {
    options = [
      { value: "send_invoice", label: "Send Invoice" },
      ...invoiceActionOptions,
    ];
  } else if (item?.status !== "PAID") {
    options = [
      { value: "send_reminder", label: "Send Reminder" },
      ...invoiceActionOptions,
    ];
  }

  const handleChange = (selectedOption) => {
    setSelected(selectedOption);
    if (selectedOption === "register_payment") {
      setInvoiceAction(selectedOption);
      setItemId(itemId);
      setShowRegister(true);
    } else if (selectedOption === "download_invoice") {
      handleDownloadInvoice(itemId);
    } else if (selectedOption === "edit") {
      window.open(`/invoices/add/${itemId}`, "_blank");
    } else if (selectedOption === "view") {
      window.open(`/invoices/${itemId}`, "_blank");
    } else if (selectedOption === "send_reminder") {
      handleSendReminder(itemId);
    } else if (selectedOption === "send_invoice") {
      setShow(true);
      // handleSendInvoice(itemId);
    } else if (selectedOption === "payments") {
      setItemId(itemId);
      setShowPayments(true);
    } else if (selectedOption === "delete") {
      setDeleteId(itemId);
      setShowDelete(true);
    } else if (selectedOption === "mark_non_recoverable") {
      setItemId(itemId);
      setShowNonRecoverable(true);
    } else if (selectedOption === 'delay_charges') {
      setItemId(itemId)
      setShowDelayCharges(true)
    }
  };

  useEffect(() => {
    if (!showRegister) {
      setInvoiceAction("");
    }
  }, [showRegister]);

  return (
    <>
      <select
        value={invoiceAction}
        onChange={(e) => handleChange(e.target.value)}
        style={{
          width: "100%",
          border: "0px",
          boxShadow: "0px",
          backgroundColor: "#EFF6FA",
          borderRadius: "5px",
          paddingRight: "0px",
          paddingLeft: "0px",
        }}
        className={`w-100 p-1 border fs-16 focus-none px-0 ${invoiceAction === "" ? "text-para" : ""
          }`}
      >
        <option kay={""} value="" disabled>
          Select
        </option>
        {options?.map((item, index) => (
          <option className="p-1" key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
      {show && (
        <Modal
          className="w-100 d-flex justify-content-center align-items-center"
          show={show}
        >
          <div
            className="w-100 d-flex flex-column justify-content-center align-items-center p-5 pt-4 gap-1"
            style={{ minWidth: "500px" }}
          >
            <div className="fs-20 fw-600">Do you want to send email? </div>
            {item?.project_array?.client_array?.contacts_array?.length > 0 && (
              <div className="w-100">
                <div className="m-3 ms-0">
                  Select Contact Options to send email:
                </div>
                <div className="d-flex flex-column gap-2 mb-4">
                  {item?.project_array?.client_array?.contacts_array
                    ?.sort((a, b) => (a?.contact_type === "PRIMARY" ? -1 : 1))
                    ?.map((contact) => (
                      <label
                        key={contact.id}
                        className="d-flex align-items-center"
                      >
                        <input
                          type="checkbox"
                          value={contact?.id}
                          onChange={() => handleCheckboxChange(contact)}
                          checked={selectedContacts.some(
                            (item) => item.id === contact?.id
                          )}
                          style={{ height: "15px", width: "15px" }}
                        />
                        <span className="ms-2 c-p">{contact?.name} </span>
                        {contact.contact_type === "PRIMARY" && (
                          <div>
                            <span className="c-p ms-1 bg-primary br-5 p-1 fs-11 text-white">
                              Primary Contact
                            </span>
                          </div>
                        )}
                      </label>
                    ))}
                </div>
              </div>
            )}
            <div className="d-flex gap-20">
              <Button
                onClick={() => {
                  // handleSendInvoice(itemId, []);
                  // handleSubmit(null, false);
                  setShow(false);
                }}
                className="border-0 px-4"
                style={{ backgroundColor: "#838383" }}
              >
                Close
              </Button>
              <Button
                onClick={() => {
                  if (selectedContacts?.length > 0) {
                    // handleSubmit(null, true);
                    handleSendInvoice(itemId, selectedContacts);
                    setShow(false);
                  } else {
                    notify(
                      "Please select atleast one contact to send email",
                      "warning"
                    );
                  }
                }}
                className="px-4"
              >
                Yes
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default InvoiceActions;
